// DOCS : https://reactrouter.com/en/main/router-components/browser-router

import { Navigate, Route, Routes as Switch, useLocation } from 'react-router-dom';

import ApplicationContainer from 'components/shared/application-container';
import { protectedRoutes } from 'constants/routes/protected-routes';
import { publicRoutes } from 'constants/routes/public-routes';
// import { lazyImport } from '../utils/lazy-import';
import { WorkspaceGuard } from 'components/controls/workspace-guard';
import { useAuth } from 'hooks/useAuth';
import { useWorkspace } from 'hooks/useWorkspace';

/**
 * Require Auth Component
 */
// const { RequireAuth } = lazyImport(() => import('./require-auth'), 'RequireAuth');

/**
 * Routes with Layout Wrapper
 */
const Routes = () => {
    const location = useLocation();
    const { role } = useAuth();
    const { baseWorkspaceUrl } = useWorkspace();

    const allowedRoutes = protectedRoutes.filter((route) => {
        return route.permissions.includes(role);
    });

    const workspaceBasePath = baseWorkspaceUrl.split('/').slice(0, 3).join('/') + '/*';

    return (
        <Switch key={role}>
            {workspaceBasePath !== '/*' && <Route path="/" element={<Navigate to={baseWorkspaceUrl} replace />} />}
            <Route path={workspaceBasePath} element={<WorkspaceGuard />}></Route>
            {allowedRoutes.length > 0 ? (
                <Route path={baseWorkspaceUrl} element={<ApplicationContainer />}>
                    {allowedRoutes.map((route) => (
                        <Route key={route.path} {...route} />
                    ))}
                </Route>
            ) : (
                <Route path="*" element={<Navigate to="/login" state={{ from: location }} replace />} />
            )}
            {/* </Route> */}
            {publicRoutes.map((route) => (
                <Route key={route.path} {...route} />
            ))}
        </Switch>
    );
};

export default Routes;
